export default {"src":"/_next/static/media/empty-state.44d5a11d.svg","height":134,"width":234};